import { Table, TableColumn, Tooltip } from '@sixfold/common-ui';
import React from 'react';
import { Link } from 'react-router';

import { StreamPrecisionIcon } from './tour_event_list';
import { Routes } from '../../routes';
import { TourVisibilitySource } from '../entities';

export interface TourVisibilitySourceListProps {
  sources: TourVisibilitySource[];
}

type VisibilitySourceRow = {
  id: React.Key;
  primarySource: string | null | undefined;
  streamPrecision: TourVisibilitySource['streamPrecision'];
  origin: string | null | undefined;
  sourceCompany: TourVisibilitySource['sourceCompany'];
  sourcePlatform: TourVisibilitySource['sourcePlatform'];
};

const columns: TableColumn<VisibilitySourceRow>[] = [
  { id: 'primarySource', title: 'Primary source', width: '25%', cellContent: ({ row }) => <>{row.primarySource}</> },
  {
    id: 'streamPrecision',
    title: 'Stream precision',
    width: '15%',
    cellContent: ({ row }) => (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Tooltip content={row.streamPrecision ?? '-'}>
          <StreamPrecisionIcon precision={row.streamPrecision ?? null} />
        </Tooltip>
      </div>
    ),
  },
  {
    id: 'origin',
    title: 'Origin',
    cellContent: ({ row }) => <>{row.origin ?? '-'}</>,
  },
  {
    id: 'sourceCompany',
    title: 'Source company',
    width: '30%',
    cellContent: ({ row }) =>
      row.sourceCompany !== null && row.sourceCompany !== undefined ? (
        <Link to={Routes.Company.generatePath({ company_id: row.sourceCompany.company_id })}>
          {row.sourceCompany.company_name ?? row.sourceCompany.company_id}
        </Link>
      ) : (
        '-'
      ),
  },
  {
    id: 'sourcePlatform',
    title: 'Source platform',
    cellContent: ({ row }) => <>{row.sourcePlatform?.platform_name ?? '-'}</>,
  },
];

export const TourVisibilitySourceList: React.FunctionComponent<TourVisibilitySourceListProps> = ({ sources }) => {
  const data: VisibilitySourceRow[] = sources.map((source, idx) => ({
    id: idx,
    primarySource: source.primaryEventSource,
    streamPrecision: source.streamPrecision,
    origin: source.eventOrigin,
    sourceCompany: source.sourceCompany,
    sourcePlatform: source.sourcePlatform,
  }));

  return (
    <>
      <h3>Visibility sources</h3>
      {data.length === 0 ? (
        <p>No visibility sources</p>
      ) : (
        <Table data={data} columns={columns} className="compact-table" />
      )}
    </>
  );
};
